import { useState } from "react";

export type SelectAllRowsParams<T> = {
  items: T[];
  checked: boolean;
  filterFn?: (item: T) => boolean;
  idKey?: keyof T;
};

export function useCheckbox() {
  const [selectedIds, setSelectedIds] = useState<Set<number>>(new Set());

  const onSelectRow = (id: number) => {
    const newSelectedIds = new Set(selectedIds);
    if (newSelectedIds.has(id)) {
      newSelectedIds.delete(id);
    } else {
      newSelectedIds.add(id);
    }
    setSelectedIds(newSelectedIds);
  };

  const onSelectAllRows = <T extends Record<string, any>>({
    items: all,
    checked,
    filterFn,
    idKey = "id" as keyof T,
  }: SelectAllRowsParams<T>) => {
    if (checked) {
      const allIds = filterFn
        ? all.filter(filterFn).map((item) => item[idKey] as number)
        : all.map((item) => item[idKey] as number);
      setSelectedIds(new Set(allIds));
    } else {
      setSelectedIds(new Set());
    }
  };
  return { selectedIds, setSelectedIds, onSelectRow, onSelectAllRows };
}
